<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      bf-header(title='Purse')
    #purse.view
</template>

<script>
  import { View } from '@/mixins/view'
  
  export default {
    name: 'view.purse',
    
    mixins: [View]
  }

</script>
